import React from 'react';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import styles from './AuthTabs.module.scss';

export const AuthTabs = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.centerContainer} role="tablist">
      <Link
        className={styles.link}
        to="/digital-signature"
        onClick={() => setActiveTab('/digital-signature')}
        role="tab"
        aria-selected={activeTab === '/digital-signature'}
      >
        <Button
          style={{ 
            color: "#000", 
            backgroundColor: activeTab === '/digital-signature' ? '' : '#E6E6E6',
            width: '100%'
          }}
          className={styles.dig}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setActiveTab('/digital-signature');
            }
          }}
        >
          {t('tabs.digitalSignature')}
        </Button>
      </Link>

      <Link
        className={styles.link}
        to="/sms"
        onClick={() => setActiveTab('/sms')}
        role="tab"
        aria-selected={activeTab === '/sms'}
      >
        <Button
          className={styles.cmc}
          style={{ 
            color: "#000", 
            backgroundColor: activeTab === '/sms' ? '' : '#E6E6E6',
            width: '100%'
          }}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setActiveTab('/sms');
            }
          }}
        >
          SMS
        </Button>
      </Link>

      <Link
        className={styles.link}
        to="/qr"
        onClick={() => setActiveTab('/qr')}
        role="tab"
        aria-selected={activeTab === '/qr'}
      >
        <Button
          className={styles.qr}
          style={{ 
            color: "#000", 
            backgroundColor: activeTab === '/qr' ? '' : '#E6E6E6',
            width: '100%'
          }}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              setActiveTab('/qr');
            }
          }}
        >
          {t('tabs.qr')}
        </Button>
      </Link>
    </div>
  );
};